import { ZAttrMeta } from "../ZAttrMeta";
import { AttrUserType } from "./AttrUserType";
import { attrUserTypes } from "./attrUserTypes";

export const getAttrUserType = (attr: ZAttrMeta): AttrUserType | undefined =>
  attrUserTypes.find(({ match }) => match(attr));
